<template>
    <div class="common_container">
        <el-form :rules="rules" ref="messageForm" :model="messageForm" label-width="100px">
            <el-form-item label="文档目录" prop="company">
                <el-cascader @visible-change="onProvincesChange"
                             ref="getDefaultValue" v-model="messageForm.company"
                             class="form-input"
                             :props="propsData"></el-cascader>
            </el-form-item>
            <el-form-item label="分类名称" prop="name">
                <el-input v-model="messageForm.name" class="form-input"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">确认</el-button>
                <el-button @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "./event.service";
    import { getRules } from "./document.rules";
    const rules = getRules();
    export default {
        props:{
            type:{//类型  默认 add =>新增    edit => 修改
                type:String,
                default:"add"
            },
            message:{//修改的信息
                type:Object,
            },
            callback: {//回掉处理
                type: Function
            }
        },
        data() {
            return {
                formName:"messageForm",
                rules:rules,
                company: ['0'],//选择上级
                propsData: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad (node, resolve) {
                        const { level } = node;
                        if(level<1){
                            services.getNoPageDirectoryList({"parentId":"0"}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }else{
                            services.getNoPageDirectoryList({"parentId":node.data.value}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }
                    }
                },
                messageForm: {//表单信息
                    level: '',
                    name: '',
                    sort: '',
                    desc: '',
                    company:['0']
                },
                valueFlag:false,
            }
        },
        mounted(){
            if(this.type == 'edit'){//返显需要修改的信息
                services.getDirectoryDetail({id:this.message.id}).then(res=>{
                    this.$refs.getDefaultValue._data.inputValue = res.parent_title;
                })
            }
        },
        created() {
            if(this.type == 'edit'){//返显需要修改的信息
                this.$modal.title = "修改";
                this.messageForm.name = this.message.title;
                this.company[0] = this.message.parentId;
                this.messageForm.company[0] = this.message.parentId;
            }
        },
        methods:{
            submit(){//提交
                let params = {
                    "title":this.messageForm.name,
                    "parentId":this.messageForm.company[this.messageForm.company.length-1],
                };
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        if(this.type == 'edit'){
                            params.id = this.message.id;
                            services.updateDirectory(params).then(res => {
                                this.$message.success("目录修改成功");
                                this.close(true);
                            }).catch(err => {
                                this.$message.error(err.message);
                            })
                        }else{
                            services.addDirectory(params).then(res => {
                                this.$message.success("目录添加成功");
                                this.close(true);
                            }).catch(err => {
                                this.$message.error(err.message);
                            })
                        }
                    };
                    return valid;
                })
            },
            onCancel(){//取消
                this.close();
            },
            close(refresh) {//关闭该弹框   refresh => true 刷新列表
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
            onProvincesChange(item) {
                // if(!item){
                //     let that = this;
                //     setTimeout(function(){
                //         if(!that.$refs.getDefaultValue._data.inputValue){
                //             that.$refs.getDefaultValue._data.inputValue = '123';
                //         }
                //     },800)
                // }
            }
        }
    }
</script>

<style scoped>
    .errorColor{
        color:red;
    }
</style>
